import { render, staticRenderFns } from "./ToggleFavourite.vue?vue&type=template&id=b1f7892c&scoped=true&"
import script from "./ToggleFavourite.vue?vue&type=script&lang=js&"
export * from "./ToggleFavourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7892c",
  null
  
)

export default component.exports